import { AbstractControl, ValidatorFn } from '@angular/forms';

export const noWhitespaces = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
        let v: string = control.value;

        if (v && v.includes(' ')) {
            return { noWhitespaces: true };
        }
        return null;
    };
};
